import { useTranslation } from 'react-i18next'
import NotificationBar from '~/components/NotificationBar'

const SmallOrderWarning: React.FC = () => {
  const { t } = useTranslation()

  return (
    <NotificationBar
      level="warning"
      text={t('lo_small_order_warning_content')}
      showIcon={false}
      showLink={false}
      showClose={false}
      style={{ marginTop: '8px' }}
    />
  )
}

export default SmallOrderWarning
